export const MONTHS = [
    {id: 1, name: 'Gennaio', max: 31},
    {id: 2, name: 'Febbraio', max: 29},
    {id: 3, name: 'Marzo', max: 31},
    {id: 4, name: 'Aprile', max: 30},
    {id: 5, name: 'Maggio', max: 31},
    {id: 6, name: 'Giugno', max: 30},
    {id: 7, name: 'Luglio', max: 31},
    {id: 8, name: 'Agosto', max: 31},
    {id: 9, name: 'Settembre', max: 30},
    {id: 10, name: 'Ottobre', max: 31},
    {id: 11, name: 'Novembre', max: 30},
    {id: 12, name: 'Dicembre', max: 31}
];

export const DAYS = [
    {id: 1, name: 'Lunedì'},
    {id: 2, name: 'Martedì'},
    {id: 3, name: 'Mercoledì'},
    {id: 4, name: 'Giovedì'},
    {id: 5, name: 'Venerdì'},
    {id: 6, name: 'Sabato'},
    {id: 7, name: 'Domenica'}
];

export const DAY_REPEAT_INMONTH = [
    {id: 1, name: 'Prima'},
    {id: 2, name: 'Seconda'},
    {id: 3, name: 'Terza'},
    {id: 4, name: 'Quarta'},
    {id: 5, name: 'Quinta'},
    {id: -5, name: 'Quintultima'},
    {id: -4, name: 'Quartultima'},
    {id: -3, name: 'Terzultima'},
    {id: -2, name: 'Penultima'},
    {id: -1, name: 'Ultima'}
];

export const GIORNI_RIF = [
    {id: 'GIORNO_STESSO', name: 'Giorno stesso'},
    {id: 'GIORNO_SUCCESSIVO', name: 'Giorno successivo'},
    {id: 'GIORNO_PRECEDENTE', name: 'Giorno precedente'},
]